import { BaseDataItem, RefSchemas } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import { createDataRef } from '../nodeFactory/dataNodeUtils'
import { builderWidgetRefResolver } from '../catharsis/catharsisUtils'

export const createRefResolver = (
	refData: RefSchemas,
	excludedPathsByDataItemType: { [dataItemType: string]: Array<string> } = {}
) => (dataItem: BaseDataItem, mapName: string, namespace = 'data') => {
	const mapKey = `${mapName}.json`

	if (mapName === 'innerElements' && dataItem.type !== 'InnerElement') {
		return builderWidgetRefResolver(dataItem, namespace, true)
	}

	if (!refData[mapKey] || !(dataItem.type in refData[mapKey])) {
		return null
	}

	const refs = refData[mapKey][dataItem.type]
	return refs.reduce((acc, { path, referencedMap }) => {
		const referencedId = _.get(dataItem, path)
		if (!referencedId || excludedPathsByDataItemType[dataItem.type]?.includes(path.join('.'))) {
			return acc
		}

		const value = Array.isArray(referencedId)
			? referencedId.map((id) => createDataRef(namespace, referencedMap, id))
			: createDataRef(namespace, referencedMap, referencedId)

		_.set(acc, path, value)

		return acc
	}, {})
}
